import TpkSelectContainerOptionsOption from '@triptyk/ember-select/components/tpk-select/options/option';
export default class TpkSelectSearchContainerOptionsOption extends TpkSelectContainerOptionsOption {}